var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBird(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 525,
    height: 66,
    viewBox: "0 0 525 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0 11.6L465 11.5L457.5 0H0V11.6Z",
    transform: "translate(0 35.8)",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.1C0 22.3 5.69999 26.6 12.8 26.6C19.8 26.6 25.6 22.3 25.6 16.1C25.6 9.9 18.1 0 12.8 0C7.59999 0 0 9.9 0 16.1Z",
    transform: "translate(498.5 38.8)",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0.57778L5.69998 7.87778H2.5L0 1.87778C0 1.87778 1.79998 0.0777769 4.19998 2.77778C4.29998 2.77778 7.39997 -1.52222 11.5 0.57778Z",
    transform: "translate(506.6 32.3222)",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.299988 0C0.299988 0 3.29999 3.4 14.3 3.9L15.5 6.2L0 5.8L0.299988 0Z",
    transform: "translate(503.7 34.7)",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6736 0C9.6736 0 12.6736 9.5 15.3736 15C17.5736 19.5 13.1736 27.5 7.1736 36.2L1.27357 36C1.27357 36 -4.8264 11.3 9.6736 0Z",
    transform: "translate(458.526 1.39999)",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 32.9C56.5 32.9 53 32.5 49.4 36.2L29 37.7C28.6 37.7 28.1 37.7 27.7 37.7H27.5C27.1 37.7 26.8 37.7 26.4 37.7C24.4 37.2 21 34.7 20.8 23C20.5 6.6 4.80002 6.3 1.80002 0C1.80002 0 -5.99999 21 13.6 35.8C12.8 36 12.1 36.3 11.3 36.6L8.20001 38C7.00001 38.5 5.69999 38.9 4.39999 39.1C2.59999 39.3 0.9 40.4 0 42H0.200012C4.60001 42.2 9.00002 43.5 12.8 45.7C14.9 46.9 17.7 47.9 21 47.4C28.2 46.2 34.7 38.3 48.3 39.4L54.4 41.5C55 41.8 55.7 42 56.5 42C59 42 61 40 61 37.5C61 35 59 32.9 56.5 32.9Z",
    transform: "translate(443.9)",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.29999 15.7V13.8C1.99999 13.8 0.7 13.4 0 13L0.5 11.7C1.3 12.2 2.39998 12.5 3.59998 12.5C5.19998 12.5 6.20001 11.7 6.20001 10.6C6.20001 9.5 5.29998 8.9 3.69998 8.3C1.49998 7.5 0.0999756 6.6 0.0999756 5C0.0999756 3.4 1.39999 2.2 3.39999 1.9V0H4.79999V1.9C6.09999 1.9 6.99998 2.2 7.59998 2.6L7.09998 3.9C6.59998 3.7 5.69999 3.2 4.29999 3.2C2.59999 3.2 2 4.1 2 4.9C2 5.9 2.79998 6.4 4.69998 7.1C6.99998 7.9 8.09998 8.9 8.09998 10.6C8.09998 12.1 6.89998 13.5 4.59998 13.9V15.9H3.29999V15.7Z",
    transform: "translate(507.2 45.9)",
    fill: "url(#paint6_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(221.776 -648.061) scale(1307.72)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-20.2712 48.8195) scale(66.0912) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-27.2737 55.2973) scale(66.0911 66.0913) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-8.6789 -7.5998) scale(21.344)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6494BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-25.8329 27.9764) scale(57.6352) rotate(-71.0149)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.6674 83.0115) scale(75.6117) rotate(-104.358)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-13.6826 16.3861) scale(35.5139 35.514) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAC1F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBird);
export default __webpack_public_path__ + "static/media/bird.2e6c2b11e2ccd9c96b53b7f3f336f410.svg";
export { ForwardRef as ReactComponent };